import React, { useState } from "react";
import "./PartnersSection.css";
import { useTranslation } from "react-i18next";
import { getPartners } from "./api";
import { useQuery } from "@tanstack/react-query";
import fallbackImg from "../../../../../assets/images/fallback.png";

function PartnersSection() {
  const { i18n } = useTranslation("home");

  const { data, isLoading } = useQuery({
    queryKey: ["partners"],
    queryFn: getPartners,
  });
  console.log(i18n.language.toLocaleLowerCase());
  if (isLoading) return <p>Loading...</p>;

  return (
    <section className="partners-page-section">
      <div className="container partners-section-container">
        {data?.map((item) => (
          <div className="services-card">
            <picture>
              <img src={item.logo_url || fallbackImg} alt="" />
            </picture>
            <div className="services-card-content">
              <h6>{item.name?.[i18n.language.toLocaleLowerCase()]}</h6>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default PartnersSection;
